import ProductsList from '../products/productList';

function Home(props) {
    return (
        <>
            <h1>Home</h1>
            <h3>Products</h3>
            <ProductsList />
        </>
    );
};

export default Home;